import { render, staticRenderFns } from "./HistoricalAgreementDetails.vue?vue&type=template&id=a3e6826c"
import script from "./HistoricalAgreementDetails.vue?vue&type=script&lang=js"
export * from "./HistoricalAgreementDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAgreementDetails.vue?vue&type=style&index=0&id=a3e6826c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports